<script setup>
defineProps({
  partners: { type: Array, default: () => [] }
})
</script>

<template>
  <ul v-if="partners.length" class="project-partners">
    <li v-for="p in partners" :key="p.ref">{{ p.organisation }}</li>
  </ul>
</template>

<style lang="scss" scoped>
// Plain bullet list until partner logos are collected — swap the <li> content
// for a logo tile here without touching callers (see jk-11-project-parties.md).
.project-partners {
  display: flex;
  flex-direction: column;
  gap: $space-2;
  padding-left: $space-5;
  color: $color-text;
}
</style>
